// FormField — label + control + hint/error, the wrapper every form row used
// to re-implement as a local `Field`. `error` takes precedence over `hint` so
// validation messages replace the helper text in the same slot (no layout
// shift).
import { ReactNode } from 'react';
import { cn } from './cn';

export interface FormFieldProps {
  readonly label: string;
  readonly htmlFor?: string;
  readonly hint?: ReactNode;
  readonly error?: ReactNode;
  readonly className?: string;
  readonly children: ReactNode;
}

export function FormField({ label, htmlFor, hint, error, className, children }: FormFieldProps) {
  let hintOrError: ReactNode;
  if (error) {
    hintOrError = <span className="block text-[11px] text-danger">{error}</span>;
  } else if (hint) {
    hintOrError = <span className="block text-[11px] text-fg-subtle">{hint}</span>;
  } else {
    hintOrError = null;
  }

  return (
    <label htmlFor={htmlFor} className={cn('block space-y-1', className)}>
      <span className="orb-section-title">{label}</span>
      {children}
      {hintOrError}
    </label>
  );
}
